import React from 'react';
import { Box, Grid, Paper, Typography, Chip } from '@mui/material';

const TabCards = ({ tabData, selectedTab, onTabChange, getTabBgColor, getTabBorderColor, getTabTextColor }) => {
  return (
    <Grid container spacing={1} columns={tabData.length * 3} sx={{ mb: 2 }}>
      {tabData.map((tab, index) => (
        <Grid item xs={3} key={index}>
          <Paper
            elevation={selectedTab === index ? 3 : 0}
            sx={{
              p: 1.5,
              cursor: 'pointer',
              bgcolor: selectedTab === index ? getTabBgColor(index) : '#fafafa',
              border: `2px solid ${selectedTab === index ? getTabBorderColor(index) : '#e0e0e0'}`,
              borderRadius: 2,
              transition: 'all 0.2s ease',
              '&:hover': {
                bgcolor: selectedTab === index ? getTabBgColor(index) : '#f5f5f5',
                transform: 'translateY(-2px)',
                boxShadow: 2,
              },
              '&:active': {
                transform: 'scale(0.98)',
              },
            }}
            onClick={() => onTabChange(index)}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                {tab.icon}
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: selectedTab === index ? 600 : 400,
                    color: selectedTab === index ? getTabTextColor(index) : '#424242',
                  }}
                >
                  {tab.label}
                </Typography>
              </Box>
              {tab.count !== undefined && (
                <Chip
                  label={tab.count}
                  size="small"
                  sx={{
                    bgcolor: selectedTab === index ? getTabBorderColor(index) : '#e0e0e0',
                    color: selectedTab === index ? '#ffffff' : '#424242',
                    fontWeight: 600,
                    fontSize: '0.75rem',
                    minWidth: 24,
                    height: 22,
                  }}
                />
              )}
            </Box>
          </Paper>
        </Grid>
      ))}
    </Grid>
  );
};

export default TabCards;